import React, {Fragment} from 'react';

import HeaderUno from '../../../Compartidos/HeaderUno';
import HeaderMetodos from '../../../../AuxiliaresPaginas/HeaderMetodos';

import { HrMetodos } from '../../../../Css/StyledHeader';
import { Flex, FlexFull, Links1Al10, ImgB10, PEj } from '../../../../Css/StyledMatematica';

const SumaTradicional = () => {

    return (
        <Fragment>
            <HeaderUno />
            <HrMetodos margin='0 0.2rem 0.5rem 0.2rem' />
            <HeaderMetodos l1={"metodos/"} l2={"matematica/"} l3={"calculo/"} l4={"suma/"} n1={"Métodos"} n2={"MATEMATICA"} n3={"CALCULO"} n4={"SUMA"} componente={"SUMA TRADICIONAL"} paciente={true} bgcolor="#23AAAF" color="white" width='96vw' shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" display="none"/>

            <Flex height='65vh'>
                <FlexFull align='center' justify='center' wrap='wrap' width='100%' wm='90%' wt='80%' wd='70%' wlg='60%'> 
                    <Flex margin='8px 0px 8px 0px' direction='column'>
                        <Links1Al10 to={`/escritorio/metodos/matematica/calculo/suma/suma-tradicional/M61`}><ImgB10 src={`/img/portadas/matematica61.jpg`} w='26vw' wm='24vw' wt='19vw' wd='16vw' wlg='14vw' border='solid 2px #23AAAF' bradius='10px' m='1vh 2.5vw 1vh 2.5vw' /></Links1Al10>
                        <PEj m='-4px' fs='2.3vw' fsm='2vw' fst='1.8vw' fsd='1.5vw' fslg='1.4vw'>PRESENTACIÓN</PEj>
                    </Flex>
                    <Flex margin='8px 0px 8px 0px' direction='column'>
                        <Links1Al10 to={`/escritorio/metodos/matematica/calculo/suma/suma-tradicional/M61Bis`}><ImgB10 src={`/img/portadas/matematica61practicaconguia.jpg`} w='26vw' wm='24vw' wt='19vw' wd='16vw' wlg='14vw' border='solid 2px #23AAAF' bradius='10px' m='1vh 2.5vw 1vh 2.5vw' /></Links1Al10>
                        <PEj m='-4px' fs='2.3vw' fsm='2vw' fst='1.8vw' fsd='1.5vw' fslg='1.4vw'>PRÁCTICA CON GUÍA</PEj>
                    </Flex>
                    <Flex margin='8px 0px 8px 0px' direction='column'>
                        <Links1Al10 to={`/escritorio/metodos/matematica/calculo/suma/suma-tradicional/M61Practica`}><ImgB10 src={`/img/portadas/matematica61practica.jpg`} w='26vw' wm='24vw' wt='19vw' wd='16vw' wlg='14vw' border='solid 2px #23AAAF' bradius='10px' m='1vh 2.5vw 1vh 2.5vw' /></Links1Al10>
                        <PEj m='-4px' fs='2.3vw' fsm='2vw' fst='1.8vw' fsd='1.5vw' fslg='1.4vw'>PRÁCTICA</PEj>
                    </Flex>
                </FlexFull>
            </Flex>
        </Fragment>    
    );
}
 
export default SumaTradicional;